import { IonCheckbox } from '@ionic/react';
import React from 'react';

import { PAYWALL_NOTES } from '@/constants/campaign-notes';
import {
  PAYWALL_TERMS_CHECKBOX_ID,
  usePaywallTermsCheckbox,
} from '@/hooks/usePaywallTermsCheckbox';
import { webCampaign } from '@/modules/webCampaign';

import { PaymentDescriptionTermsAndLinks } from './Description';
import {
  SubscriptionManageHint,
  TermsCheckboxLabel,
} from './Description.styles';

export const BillingTermsWithCheckbox: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const paywallNotes = webCampaign.setup.paywallNotes;
  const requireTermsCheckbox = paywallNotes.includes(
    PAYWALL_NOTES.REQUIRE_TERMS_CHECKBOX,
  );

  const showManageHint = paywallNotes.includes(
    PAYWALL_NOTES.SHOW_SUBSCRIPTION_MANAGE_HINT,
  );

  const { isChecked, isHighlighted, setChecked, setHighlighted } =
    usePaywallTermsCheckbox();

  const handleCheckboxChange = (checked: boolean) => {
    setChecked(checked);
    if (checked) {
      setHighlighted(false);
    }
  };

  if (requireTermsCheckbox) {
    return (
      <>
        <TermsCheckboxLabel
          id={PAYWALL_TERMS_CHECKBOX_ID}
          $isHighlighted={isHighlighted}
        >
          <IonCheckbox
            checked={isChecked}
            onIonChange={(e) => handleCheckboxChange(e.detail.checked)}
            className="terms-checkbox"
          />
          <span>
            {children} <PaymentDescriptionTermsAndLinks />
          </span>
        </TermsCheckboxLabel>
        {showManageHint && (
          <SubscriptionManageHint>
            You can manage or cancel your subscription at any time in your
            account settings on the Lure AI website.
          </SubscriptionManageHint>
        )}
      </>
    );
  }

  return <>{children}</>;
};
